"use strict";

var _regeneratorRuntime2 = require("@babel/runtime/regenerator");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = create;
exports.deleteCamera = deleteCamera;
exports.edit = edit;
exports.fetchPreview = fetchPreview;
exports.gateCameraWatcher = gateCameraWatcher;
exports.list = list;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _effects = require("redux-saga/effects");
var _services = require("../../../services");
var _variables = require("../variables");
var _helpers = require("@qwkin/helpers");
var _variables2 = require("../../Notification/variables");
var _utils = require("../../../utils");
var _marked = /*#__PURE__*/_regeneratorRuntime2.mark(gateCameraWatcher);
function list(_ref) {
  var payload = _ref.payload,
    _ref$callback = _ref.callback,
    callback = _ref$callback === void 0 ? _helpers.identity : _ref$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var response, _response$data, _response$data2, _response;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.call)(_services.GateCameraService.list, payload);
        case 3:
          response = _context.sent;
          _context.next = 6;
          return (0, _effects.put)({
            type: _variables.LIST_GATE_CAMERA_SUCCESS,
            payload: response
          });
        case 6:
          callback();
          _context.next = 17;
          break;
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](0);
          _response = _context.t0.response;
          _context.next = 14;
          return (0, _effects.put)({
            type: _variables.LIST_GATE_CAMERA_FAIL,
            payload: _response
          });
        case 14:
          _context.next = 16;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response$data = _response === null || _response === void 0 ? void 0 : _response.data) !== null && _response$data !== void 0 ? _response$data : {}),
              data: _response
            }
          });
        case 16:
          (0, _utils.logErr)((_response$data2 = _response === null || _response === void 0 ? void 0 : _response.data) !== null && _response$data2 !== void 0 ? _response$data2 : {});
        case 17:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 9]]);
  })();
}
function deleteCamera(_ref3) {
  var payload = _ref3.payload,
    _ref3$callback = _ref3.callback,
    callback = _ref3$callback === void 0 ? _helpers.identity : _ref3$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
    var response, _response2$data, _response2$data2, _response2;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.call)(_services.GateCameraService["delete"], payload);
        case 3:
          response = _context2.sent;
          _context2.next = 6;
          return (0, _effects.put)({
            type: _variables.DELETE_GATE_CAMERA_SUCCESS,
            payload: response
          });
        case 6:
          _context2.next = 8;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Camera deleted successfully'
            }
          });
        case 8:
          callback();
          _context2.next = 19;
          break;
        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](0);
          _response2 = _context2.t0.response;
          _context2.next = 16;
          return (0, _effects.put)({
            type: _variables.DELETE_GATE_CAMERA_FAIL,
            payload: _response2
          });
        case 16:
          _context2.next = 18;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response2$data = _response2 === null || _response2 === void 0 ? void 0 : _response2.data) !== null && _response2$data !== void 0 ? _response2$data : {}),
              data: _response2
            }
          });
        case 18:
          (0, _utils.logErr)((_response2$data2 = _response2 === null || _response2 === void 0 ? void 0 : _response2.data) !== null && _response2$data2 !== void 0 ? _response2$data2 : {});
        case 19:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 11]]);
  })();
}
function create(_ref5) {
  var payload = _ref5.payload,
    _ref5$callback = _ref5.callback,
    callback = _ref5$callback === void 0 ? _helpers.identity : _ref5$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
    var response, _response3$data, _response3$data2, _response3;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return (0, _effects.call)(_services.GateCameraService.create, payload);
        case 3:
          response = _context3.sent;
          _context3.next = 6;
          return (0, _effects.put)({
            type: _variables.CREATE_GATE_CAMERA_SUCCESS,
            payload: response
          });
        case 6:
          _context3.next = 8;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Camera created successfully'
            }
          });
        case 8:
          callback();
          _context3.next = 19;
          break;
        case 11:
          _context3.prev = 11;
          _context3.t0 = _context3["catch"](0);
          _response3 = _context3.t0.response;
          _context3.next = 16;
          return (0, _effects.put)({
            type: _variables.CREATE_GATE_CAMERA_FAIL,
            payload: _response3
          });
        case 16:
          _context3.next = 18;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response3$data = _response3 === null || _response3 === void 0 ? void 0 : _response3.data) !== null && _response3$data !== void 0 ? _response3$data : {}),
              data: _response3
            }
          });
        case 18:
          (0, _utils.logErr)((_response3$data2 = _response3 === null || _response3 === void 0 ? void 0 : _response3.data) !== null && _response3$data2 !== void 0 ? _response3$data2 : {});
        case 19:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 11]]);
  })();
}
function edit(_ref7) {
  var payload = _ref7.payload,
    _ref7$callback = _ref7.callback,
    callback = _ref7$callback === void 0 ? _helpers.identity : _ref7$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
    var response, _response4$data, _response4$data2, _response4;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return (0, _effects.call)(_services.GateCameraService.edit, payload);
        case 3:
          response = _context4.sent;
          _context4.next = 6;
          return (0, _effects.put)({
            type: _variables.EDIT_GATE_CAMERA_SUCCESS,
            payload: response
          });
        case 6:
          _context4.next = 8;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Camera edited successfully'
            }
          });
        case 8:
          callback();
          _context4.next = 19;
          break;
        case 11:
          _context4.prev = 11;
          _context4.t0 = _context4["catch"](0);
          _response4 = _context4.t0.response;
          _context4.next = 16;
          return (0, _effects.put)({
            type: _variables.EDIT_GATE_CAMERA_FAIL,
            payload: _response4
          });
        case 16:
          _context4.next = 18;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response4$data = _response4 === null || _response4 === void 0 ? void 0 : _response4.data) !== null && _response4$data !== void 0 ? _response4$data : {}),
              data: _response4
            }
          });
        case 18:
          (0, _utils.logErr)((_response4$data2 = _response4 === null || _response4 === void 0 ? void 0 : _response4.data) !== null && _response4$data2 !== void 0 ? _response4$data2 : {});
        case 19:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[0, 11]]);
  })();
}
function fetchPreview(_ref9) {
  var payload = _ref9.payload,
    _ref9$callback = _ref9.callback,
    callback = _ref9$callback === void 0 ? _helpers.identity : _ref9$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
    var _response$data3, response, _response5$data, _response5;
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _context5.next = 3;
          return (0, _effects.call)(_services.GateCameraService.fetchImagePreview, payload);
        case 3:
          response = _context5.sent;
          _context5.next = 6;
          return (0, _effects.put)({
            type: _variables.FETCH_PREVIEW_GATE_CAMERA_SUCCESS,
            payload: response
          });
        case 6:
          callback({
            success: true,
            data: (_response$data3 = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data3 !== void 0 ? _response$data3 : {}
          });
          _context5.next = 18;
          break;
        case 9:
          _context5.prev = 9;
          _context5.t0 = _context5["catch"](0);
          _response5 = _context5.t0.response;
          _context5.next = 14;
          return (0, _effects.put)({
            type: _variables.FETCH_PREVIEW_GATE_CAMERA_FAIL,
            payload: _response5
          });
        case 14:
          _context5.next = 16;
          return (0, _effects.put)({
            type: _variables2.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response5$data = _response5 === null || _response5 === void 0 ? void 0 : _response5.data) !== null && _response5$data !== void 0 ? _response5$data : {})
            }
          });
        case 16:
          callback({
            success: false
          });
          (0, _utils.logErr)(_response5);
        case 18:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[0, 9]]);
  })();
}
function gateCameraWatcher() {
  return _regenerator["default"].wrap(function gateCameraWatcher$(_context6) {
    while (1) switch (_context6.prev = _context6.next) {
      case 0:
        _context6.next = 2;
        return (0, _effects.all)([(0, _effects.takeLatest)(_variables.CREATE_GATE_CAMERA_REQUEST, create), (0, _effects.takeLatest)(_variables.LIST_GATE_CAMERA_REQUEST, list), (0, _effects.takeLatest)(_variables.EDIT_GATE_CAMERA_REQUEST, edit), (0, _effects.takeLatest)(_variables.DELETE_GATE_CAMERA_REQUEST, deleteCamera), (0, _effects.takeLatest)(_variables.FETCH_PREVIEW_GATE_CAMERA_REQUEST, fetchPreview)]);
      case 2:
      case "end":
        return _context6.stop();
    }
  }, _marked);
}